import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import { Breadcrumbs, Link, TablePagination, Typography } from "@mui/material";
import RefreshButton from "../../../../../common/components/refresh_button";
import { useMemo } from "react";
import { GenerateQualidadeProcessosRiscosColumns } from "./columns/qualidade_processos_riscos";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { Header } from "./components/header";
import { ProcessoRiscosModal } from "./components/processo_risco_modal";
import { useQualidadeProcessoRiscosListaViewModel } from "../../viewModels/qualidade_processos_riscos_view_model";
import { ProcessoRiscosLista } from "../../../domain/models/processos_riscos_lista";
import { CopiaProcessoRiscoModal } from "./components/copia_processo_risco_modal";
import { useNavigate } from "react-router";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";

export const ProcessosRiscos = () => {
  const viewModel = useQualidadeProcessoRiscosListaViewModel();
  const navigate = useNavigate();

  const QualidadeProcessoRiscosListalColumns = useMemo(() => {
    return GenerateQualidadeProcessosRiscosColumns({
      onActionEditar: viewModel.handleCadastroProcessosRiscosOpenState,
      onActionDeletar: viewModel.handleDeleteProcessoRiscosModalOpenState,
      onActionCopiar: viewModel.handleProcessoRiscosCopiaOpenState,
      navigate: navigate
    });
  }, [navigate, viewModel.handleCadastroProcessosRiscosOpenState, viewModel.handleDeleteProcessoRiscosModalOpenState, viewModel.handleProcessoRiscosCopiaOpenState]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[150px] ">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onClick={() => viewModel.handleCadastroProcessosRiscosOpenState(null, true)}>
                  Novo
                </PrimaryButton>
              </div>
            </div>
          } />
      </PageTopBar>
      <form>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Qualidade
            </Link>
            <Typography className="text-primary-green">
              Processos e Riscos
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Processos e Riscos</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>
          </div>
          <Header
            onClearFilters={viewModel.handleClearFilters}
            handlePesquisa={viewModel.handlePesquisaChange}
            pesquisa={viewModel.filters.pesquisa}

          />

          <StyledDataGrid
            tableName="ProcessoRiscosLista"
            disableColumnMenu={false}
            getRowId={(row: ProcessoRiscosLista) => row.IdProcesso}
            columns={QualidadeProcessoRiscosListalColumns}
            loading={viewModel.loading}
            rows={viewModel.ProcessoRiscosLista}
            rowCount={viewModel.pagination.totalItems}
            sx={{
              '& .status-header': {
                backgroundColor: '#AFDFD5',
                color: '#000'
              }
            }}
            pageSizeOptions={[10]}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page,
              pageSize: viewModel.pagination.rowsPerPage,
            }} />

          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
        </div>
      </form>

      {/* Modal */}
      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />

      <ProcessoRiscosModal
        loading={viewModel.loading}
        onClose={() => viewModel.handleCadastroProcessosRiscosOpenState(null, false)}
        onSubmit={viewModel.handleProcessoRiscosSubmit}
        open={viewModel.ProcessosRiscosModal}
        saving={viewModel.saving}
        selectedProcessoRiscos={viewModel.selectedProcessosRiscos}
        onOpenChangeHistory={(id, tabelaTipo) => viewModel.handleOpenChangeHistory(id, tabelaTipo)} />

      {/* Deletar Registro */}
      <DeleteDialog
        open={viewModel.ProcessosRiscosDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteProcessoRiscosModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaProcessoRiscos} />

      {/* ModalCopia */}
      <CopiaProcessoRiscoModal
        open={viewModel.openCopiaModal}
        saving={viewModel.saving}
        selectedProcessoRiscosCopia={viewModel.selectedProcessosRiscos}
        titulo={"teste"}
        onSubmit={viewModel.handleSubmitCopiaProcessoRiscos}
        onClose={() => viewModel.handleProcessoRiscosCopiaOpenState(null, false)}
      />
    </>
  )
}